import { render } from "./LobbySlider.vue?vue&type=template&id=dc482240"
import script from "./LobbySlider.vue?vue&type=script&lang=js"
export * from "./LobbySlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__